'use client';

import {
    Alignable,
    Box,
    BoxContent,
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Row,
    Rows,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TitleMarkup,
    TrilogyColor,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

type EconomyBlockProps = {
    categoryTitle?: string;
    economyWording: string;
    iconName: IconName;
};
export function EconomyBlock({ categoryTitle, economyWording, iconName }: EconomyBlockProps) {
    return (
        <Box shadowless className='has-text-centered'>
            <BoxContent backgroundColor={TrilogyColor.MAIN_FADE}>
                <Rows>
                    {categoryTitle ? (
                        <Row>
                            <Title
                                markup={TitleMarkup.H2}
                                typo={TypographyAlign.TEXT_CENTERED}
                                level={TitleLevels.THREE}
                            >
                                {categoryTitle}
                            </Title>
                        </Row>
                    ) : null}
                    <Row>
                        <Columns
                            align={Alignable.ALIGNED_CENTER}
                            verticalAlign={Alignable.ALIGNED_CENTER}
                            mobile
                            multiline
                        >
                            <Column narrow>
                                <Icon size={IconSize.LARGE} name={IconName.BOX_EOLE} />
                            </Column>

                            <Column narrow>
                                <Icon size={IconSize.SMALL} name={IconName.PLUS} />
                            </Column>
                            <Column narrow>
                                <Icon size={IconSize.LARGE} name={iconName} />
                            </Column>
                            <Column narrow>
                                <Icon size={IconSize.SMALL} name={IconName.EQUAL} />
                            </Column>
                            <Column desktopSize={5}>
                                <Text
                                    typo={[TypographyBold.TEXT_WEIGHT_SEMIBOLD, TypographyAlign.TEXT_CENTERED]}
                                    marginless
                                    level={TextLevels.ONE}
                                >
                                    {economyWording}
                                </Text>
                            </Column>
                        </Columns>
                    </Row>
                </Rows>
            </BoxContent>
        </Box>
    );
}
